"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTrackEventContext = exports.getCoreEventContext = void 0;
const web_utils_1 = require("@checkatrade/web-utils");
const date_1 = require("./utils/date");
const sessionDurationSeconds = 30 * 60;
const sessionKey = 'cat-session-id';
const domain = 'checkatrade.com';
const getAndRefreshSessionId = () => {
    const sessionId = (0, web_utils_1.getCookie)(sessionKey) || (0, web_utils_1.uuidV4)();
    (0, web_utils_1.setCookie)(sessionKey, sessionId, {
        maxAgeSeconds: sessionDurationSeconds,
        domain,
    });
    return sessionId;
};
const getCoreEventContext = (appVersion = 'unknown-app-version', environment = 'unknown-environment', runtimeContext) => {
    const time = new Date();
    return {
        ts: time.toISOString(),
        ts_local: (0, date_1.convertUTCDateToLocalDate)(time).toISOString(),
        app_version: appVersion,
        environment,
        device_id: (0, web_utils_1.getDeviceId)(),
        session: getAndRefreshSessionId(),
        user_id: runtimeContext?.userId || null,
    };
};
exports.getCoreEventContext = getCoreEventContext;
const getTrackEventContext = () => {
    const pageUrl = new URL(window.location.href);
    return {
        page_url: `${pageUrl.pathname}${pageUrl.search || ''}`,
        browser_width: window.innerWidth,
        browser_height: window.innerHeight,
        product_language: 'en-GB',
        os_language: navigator.language,
    };
};
exports.getTrackEventContext = getTrackEventContext;
//# sourceMappingURL=context.js.map